

define(['squid/index', 'text!./template.html', 'components/xo-models/src/auth/index', 'components/xo-ui-components/src/popup/directive', 'components/xo-ui-components/src/error-tooltip/directive', 'components/xo-models/src/checkout/index', 'components/xo-models/src/credit/index', 'components/xo-models/src/user/index', 'components/xo-device-info/dist/index'], function (squid, template) {

    squid.module('xo-login.directive', ['squid', 'xomodel.auth', 'xomodel.checkout', 'xomodel.credit', 'xomodel.user', 'xo-popup.directive', 'xo-error-tooltip.directive', 'xo-device-info', 'xo-fn']).directive('xoLogin', function () {

        return {
            template: template,

            scope: {
                token: '=',
                doneFn: '=',
                errorFn: '=',
                clientId: '=',
                redirectUri: '=',
                scope: '=',
                autoLogin: '=',
                apsIntegration: '=',
                batch: '=',
                loginSubmit: '='
            },

            controller: function controller($scope, $element, $populate, $rootScope, $locale, $config, $window, $AuthModel, $CheckoutCartModel, $CheckoutInputDataModel, $CreditDataModel, $logger, $feature, $DeviceInfo, $util, $fn) {

                $scope.locale = $locale;

                var localeNVP = 'locale.x=' + $locale.lang.toLowerCase() + '_' + $locale.country;
                var forgotPasswordUrl = 'https://www.paypal.com/' + $locale.country.toLowerCase() + '/webapps/accountrecovery/passwordrecovery?' + localeNVP;
                var legacyForgotPasswordUrl = 'https://www.paypal.com/' + $locale.country.toLowerCase() + '/merchantpaymentweb?cmd=_account-recovery&from=PayPal&' + localeNVP;
                var checkoutInputData = $CheckoutInputDataModel.instance($rootScope.token);
                var creditData = $CreditDataModel.instance($rootScope.token);
                var apsRemMe = $scope.apsIntegration === 'apsIntegrationRM';
                var fptiStateName = $scope.apsIntegration ? 'LOGIN_APS' : 'LOGIN';
                var $passwordField = $element.find('[ng-model="auth.password"]');

                $scope.forgotPasswordUrl = $feature('newForgotPasswordSupported') ? forgotPasswordUrl : legacyForgotPasswordUrl;

                $fn.sendTypingSpeedPayload('Hermes');

                /* ******** Here goes the Remember User controls *************************** */

                // Show the RM consent section when
                // 1. feature is ON
                // 2. when its not a contingency flow
                // 3. eBay doesn't want to hide it explicitly

                if (checkoutInputData.rmEnabled(Boolean($config.rememberMeFeatureEnabled)) && !checkoutInputData.hideRM()) {
                    fptiStateName = 'LOGIN_RM';
                    $scope.rememberMe = 'nonKmli';
                } else if (apsRemMe) {
                    $scope.rememberMe = 'kmli';
                }
                $scope.rememberMeChkBox = {
                    // Leave the consent box un-ticked by default
                    agreed: false
                };

                // Show the RM details only if user clicks on 'learn more' link or clicks on Checkbox
                $scope.showRmMore = false;

                // Expand details when RM check-box is ticked and Remember the user
                $scope.toggleRMDetails = function () {
                    $scope.showRmMore = $scope.rememberMeChkBox.agreed;
                };

                function setRememberUser() {

                    if (checkoutInputData.rmEnabled(Boolean($config.rememberMeFeatureEnabled))) {
                        if (checkoutInputData.hideRM() === 'true') {
                            // Feature is ON but consent box is hidden since hideRM param is true
                            // Do not remember user in this case
                            $scope.auth.rememberUser = false;
                        } else {
                            // RM is enabled and consent box displayed on login page
                            // Remember the user based on the consent of user
                            $scope.auth.rememberUser = $scope.rememberMeChkBox.agreed ? true : false;
                        }
                    } else {
                        // Feature is wired off
                        // If RM is not enabled that means the control is with eBay and we should retain current behavior by remembering the user
                        $scope.auth.rememberUser = true;
                    }
                }

                /* ************ Remember User Ends *************************************** */

                function showLoadingMessage() {
                    $rootScope.$emit('loadingMessage', $locale.content.get(creditData.isRedirectFromCape() || creditData.isChangeStatus() ? 'base.processing' : 'base.loggingIn'));
                }

                function loginAction() {
                    showLoadingMessage();
                    var loginInput = {
                        user: {
                            email: $scope.auth.email,
                            password: $scope.auth.password
                        }
                    };

                    if ($scope.clientId) {
                        loginInput.client = {
                            redirect_uri: $config.app_redirect_uri,
                            client_id: $config.app_clientId || '',
                            target_client_id: $util.base64Decode($scope.clientId), // eslint-disable-line block-scoped-var,no-undef
                            scope: $scope.scope,
                            response_type: 'token id_token',
                            skip_oauth: false,
                            skip_consent: true
                        };
                    } else if ($scope.apsIntegration) {
                        loginInput.client = {
                            remember_me: Boolean(apsRemMe && $scope.rememberMeChkBox.agreed)
                        };
                        loginInput.fastLogin = true;
                    }

                    // updated the product to decide the entry point
                    loginInput.product = $rootScope.wps ? 'wps' : 'ec';

                    $scope.auth.action('login', {

                        data: loginInput,

                        success: function success(result) {
                            var transition_name = $scope.rememberMeChkBox.agreed ? 'process_login_rm' : 'process_login';
                            $logger.info('checkout_fpti', { 'from': fptiStateName, 'to': transition_name });
                            return $scope.doneFn($scope.auth);
                        },

                        contingencies: {
                            DEFAULT: function handleContingency(name, contingency) {
                                var transition_name = $scope.rememberMeChkBox.agreed ? 'process_login_rm' : 'process_login';
                                var error_source = $scope.apsIntegration ? 'aps' : 'userauth';

                                $logger.info('checkout_fpti', {
                                    'from': fptiStateName,
                                    'to': transition_name,
                                    'int_error_description': contingency && contingency.message,
                                    'error_type': 'soft_decline',
                                    'error_source': error_source
                                });
                                $scope.auth.password = '';
                                $passwordField.focus();
                                return $scope.errorFn(name, contingency);
                            }
                        }
                    });
                }

                $scope.$on('$destroy', function () {
                    $scope.auth.password = '';
                });

                $populate($scope, {
                    auth: $AuthModel.instance(),
                    checkoutCart: $CheckoutCartModel.instance($scope.token)
                }).then(function () {
                    if ($scope.auth.loggedIn()) {
                        if ($scope.autoLogin) {
                            showLoadingMessage();
                            if ($scope.auth.remembered) {
                                $logger.info('REMEMBERED_ACTIVE_SESSION');
                            } else {
                                $logger.info('ACTIVE_SESSION');
                            }
                            return $scope.doneFn($scope.auth);
                        }
                    } else if ($scope.checkoutCart.payer && $scope.checkoutCart.payer.email && !$scope.auth.timed_out) {
                        $scope.auth.email = $scope.checkoutCart.payer.email;
                    }
                    var transition_name;
                    if (apsRemMe) {
                        transition_name = 'prepare_login_rm';
                    } else if (creditData.isCreditTxn()) {
                        transition_name = 'prepare_login_ppc';
                    } else {
                        transition_name = 'prepare_login';
                    }

                    var app_int_type = $DeviceInfo.getAppIntegrationType();
                    $logger.info('checkout_fpti', {
                        'from': fptiStateName,
                        'to': transition_name,
                        'app_int_type': app_int_type
                    });
                    $scope.onSubmit = function () {
                        setRememberUser();
                        loginAction();
                    };
                });
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-login-components/src/login/directive.js
 ** module id = 191
 ** module chunks = 1
 **/